// Auto-generated from proto definitions. DO NOT EDIT.

export type ChannelScope = 'CHANNEL_SCOPE_UNSPECIFIED' | 'CHANNEL_SCOPE_PLATFORM' | 'CHANNEL_SCOPE_TENANT' | 'CHANNEL_SCOPE_TEAM' | 'CHANNEL_SCOPE_USER';

export const ChannelScopeValues = ['CHANNEL_SCOPE_UNSPECIFIED', 'CHANNEL_SCOPE_PLATFORM', 'CHANNEL_SCOPE_TENANT', 'CHANNEL_SCOPE_TEAM', 'CHANNEL_SCOPE_USER'] as const;
